import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { styles } from './Column.scss';
import './Column.css';

const Column = ({zmarli, rzad, sektor, id}) => (
    <div className="Column_l">
        <div className="Column">{
            zmarli.map(zm => (
                <div>
                    <p className="Text">{zm.imie}</p>
                    <p className="Text">{zm.nazwisko}</p>
                    <p className="Text">ur:&nbsp;{zm.data_urodzenia}</p>
                    <p className="Text">&#10013;{zm.data_zgonu}</p>
                </div>
            ))}
            <p className="Text">Rząd:&nbsp;{rzad}</p>
            <p className="Text">Sektor:&nbsp;{sektor}</p>
            <p className="Text">Id:&nbsp;{id}</p></div>
        <div className="Line"></div>
    </div>
    )

export default withStyles(styles)(Column);



// WEBPACK FOOTER //
// src/components/MapControl/gravePopup/Column.js